import React, {FC, useEffect, useMemo, useState} from "react";
import Glide from "@glidejs/glide";
import useNcId from "hooks/useNcId";

export interface SectionSliderBannerProps {
  className?: string;
  itemClassName?: string;
  imgs: string[];
  uniqueClassName: string;
}

const SectionSliderEvent: FC<SectionSliderBannerProps> = ({
  className = "",
  itemClassName = "",
  imgs,
  uniqueClassName,
}) => {
  const UNIQUE_CLASS =
    "SectionSliderNewCategories__" + uniqueClassName + useNcId();
  const [, setActiveIndex] = useState(0);

  const MY_GLIDEJS = useMemo(() => {
    return new Glide(`.${UNIQUE_CLASS}`, {
      type: "carousel",
      perView: 1,
      focusAt: "center",
      gap: 0,
      peek: {before: 0, after: 0},
      autoplay: 4000,
      animationDuration: 600,
      dragThreshold: 80,
      swipeThreshold: 120,

      breakpoints: {
        1024: {perView: 1, peek: {before: 0, after: 0}},
        768: {perView: 1, peek: {before: 0, after: 0}},
      },
    });
  }, [UNIQUE_CLASS]);

  useEffect(() => {
    MY_GLIDEJS.mount();
    MY_GLIDEJS.on("run.after", () => setActiveIndex(MY_GLIDEJS.index));

    return () => {
      MY_GLIDEJS.destroy();
    };
  }, [MY_GLIDEJS]);

  return (
    <div className={`absolute inset-0 w-full h-full ${className}`}>
      <div className={`${UNIQUE_CLASS} relative w-full h-full overflow-hidden`}>
        <div className="glide__track h-full" data-glide-el="track">
          <ul className="glide__slides h-full">
            {imgs.map((item, index) => (
              <li
                key={index}
                className={`glide__slide h-full ${itemClassName}`}
              >
                <img
                  className="w-full h-full object-cover rounded-md sm:rounded-xl"
                  src={item}
                  alt={`banner-${index}`}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SectionSliderEvent;
